import { useRootStore } from '../../stores/BridgeProvider';

function permissionCheck(val) {
  const { orgStore } = useRootStore();
  const permList = orgStore.permissions;

  if (!val) {
    return true;
  }
  return !permList ? false : Object.keys(permList).includes(val);
}

export default permissionCheck;
